<template>
  <div>
    <div class="container px-3 py-2">
      <!-- <div class="mb-2">
        <ValidationObserver ref="obs">
          <div class="mt-2 input required">Hoạt động</div>
          <ValidationProvider
            name="Hoạt động"
            rules="required-input: tên hoạt động"
            v-slot="{ errors }"
          >
            <el-input
              placeholder="Nhập tên hoạt động"
              v-model="formData.title"
            ></el-input>
            <div v-if="errors[0]" class="mt-1 ms-1">
              <InputError :message="errors[0]" />
            </div>
          </ValidationProvider>
        </ValidationObserver>
      </div> -->

      <!-- <div class="row mb-2">
        <div class="col-6 pe-1">
          <p class="mb-2">Ngày tạo</p>
          <el-date-picker
            :picker-options="pickerOptions"
            v-model="formData.createTime"
            class="w-100"
            type="date"
            format="yyyy/MM/dd"
            prefix-icon="icon-date-1"
            @change="updatePickerOptions"
          ></el-date-picker>
        </div>
        <div class="col-6 ps-1">
          <p class="mb-2">Người tham gia</p>
          <el-select
            multiple
            collapse-tags
            class="w-100"
            placeholder="Chọn người tham gia"
            v-model="formData.selectedEmployee"
          >
            <el-option
              v-for="user in employeeOptions"
              :key="user.username"
              :value="user.username"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6 pe-1">
          <p class="mb-2">Giờ bắt đầu</p>
          <el-time-picker
            class="w-100 custom"
            v-model="formData.startTime"
            type="datetime"
            placeholder="00:00:00"
            prefix-icon="icon-time"
            :picker-options="startTimeOptions"
            @change="updateEndTimeOptions"
          ></el-time-picker>
        </div>
        <div class="col-6 ps-1">
          <p class="mb-2">Giờ kết thúc</p>
          <el-time-picker
            :disabled="!formData.startTime"
            class="w-100"
            v-model="formData.endTime"
            type="datetime"
            placeholder="00:00:00"
            prefix-icon="icon-time"
            :picker-options="endTimeOptions"
          ></el-time-picker>
        </div>
      </div> -->
      <div class="mb-2">
        <ValidationObserver ref="obs">
          <div class="mt-2 input required">Ghi chú</div>
          <ValidationProvider
            name="Hoạt động"
            rules="required-input: ghi chú "
            v-slot="{ errors }"
          >
            <div class="input-wrapper">
              <el-input
                ref="noteInput"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                placeholder="Thêm ghi chú"
                v-model="formData.note"
                @input="onInput"
                @keydown.native="onKeyDown"
              ></el-input>
              <div class="d-flex align-items-center mt-1 gap-2">
                <el-button size="mini" @click="openMentionByButton">@</el-button>

                <div v-if="showMention" ref="mentionDropdown" class="mention-dropdown" :style="{ top: dropdownTop + 'px', left: dropdownLeft + 'px' }">
                  <div
                    v-for="emp in filteredEmployees"
                    :key="emp.id"
                    class="mention-item"
                    @click="selectMention(emp)"
                  >
                    {{ emp.username }}
                  </div>
                </div>
              </div>
              <!-- <div class="d-flex flex-row-reverse" style="font-size: 12px; color: gray">
                {{ formData.note.length }} / 230
              </div> -->
            </div>

            <div v-if="errors[0]" class="mt-1 ms-1">
              <InputError :message="errors[0]" />
            </div>
          </ValidationProvider>
        </ValidationObserver>
      </div>
      <!-- <div
        class="my-1 d-flex align-items-center pb-2"
      >
        <el-checkbox v-model="formData.notification"></el-checkbox>
        <span class="ms-2">Thông báo lịch hẹn trước</span>
        <el-input
          :disabled="!formData.notification"
          placeholder="1"
          size="small"
          class="mx-2 notification"
          style="max-width: 50px"
          v-model="formData.time"
          type="number"
          :min="1"
        ></el-input>
        <el-select
          :disabled="!formData.notification"
          v-model="value"
          placeholder="Phút"
          style="width: 80px"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div> -->
      <div class="pb-1" style="border-bottom: 1px #ececec solid">
        <p class="mb-2">Chọn file để tải lên :</p>
        <div v-if="files.length === 0">
          <div class="d-flex" @click="$refs.files.click()">
            <el-input class="upload-input" placeholder="Chọn file..." readonly></el-input>
            <el-button type="info" style="border-radius: 0px 4px 4px 0px"
              >Browse</el-button
            >
          </div>
          <input
            style="display: none; width: 0; height: 0"
            ref="files"
            type="file"
            multiple
            @change="fileSelected"
          />
        </div>
        <div v-else>
          <div
            class="d-flex justify-content-between align-items-center"
            v-for="file in files"
            :key="file"
          >
            <span class="text-decoration-underline text-ellipsis">{{ file.name }}</span>
            <div @click="removeFile(file)" style="cursor: pointer">
              <IconFont name="icon-close" />
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer py-2 d-flex justify-content-end">
        <el-button v-if="!mandatory" class="" size="medium" @click="close">Huỷ</el-button>
        <el-button
          size="medium"
          type="primary"
          @click="createHistory"
          :disabled="!formData.note.trim()"
          >Tạo ghi chú</el-button
        >
      </span>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/lib/http-common";
import IconFont from "../common/IconFont.vue";
export default {
  props: {
    selectedContact: {
      type: Object,
      default: null,
    },
    steps: {
      type: Array,
      default: () => [],
    },
    processId: {},
    mandatory: {
      type: Boolean,
      default: false,
    },
    workflowIdOverride: {
      type: [String, Number],
      default: null,
    },
    contactIds: {
      type: Array,
      default: null,
    },
    IconFont,
  },
  data() {
    const now = new Date();
    const tenMinutesLater = new Date(now.getTime() + 10 * 60 * 1000);
    return {
      employeeOptions: [],
      formData: {
        title: "",
        startTime: now,
        createTime: now,
        endTime: tenMinutesLater,
        note: "",
        time: "",
        selectedEmployee: [],
        fileIds: "",
        processId: "",
        workflowId: "",
      },
      options: [
        { value: "Phút", label: "Phút" },
        { value: "Giờ", label: "Giờ" },
      ],
      pickerOptions: {
        disabledDate(time) {
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          return time.getTime() < yesterday.getTime();
        },
      },
      startTimeOptions: {},
      endTimeOptions: {},
      value: "",
      files: [],
      filteredEmployees: [],  // danh sách hiển thị dropdown
      mentions: [],           // list mention đã chọn
      showMention: false,
      mentionIndex: -1,       // vị trí bắt đầu '@'
      cursorPos: 0,
      dropdownTop: 0,
      dropdownLeft: 0,
      isOpeningMention: false,
    };
  },
  methods: {
    onKeyDown(e) {
      const textarea = e.target

      if (e.key === 'Enter' && e.shiftKey) {
        return;
      }

      if (e.key === 'Enter') {
        e.preventDefault();
        this.createHistory();
        return;
      }

      if (e.code === 'Digit2' && e.shiftKey) {
        e.preventDefault();

        this.cursorPos = textarea.selectionStart;
        this.mentionIndex = this.cursorPos;

        this.formData.note =
          this.formData.note.slice(0, this.cursorPos) +
          '@' +
          this.formData.note.slice(this.cursorPos);

        this.cursorPos += 1;

        this.$nextTick(() => {
          textarea.setSelectionRange(this.cursorPos, this.cursorPos);
          this.openMention(textarea);
        });
      }
    },
    onInput() {
      const textarea = this.$refs.noteInput?.$el?.querySelector('textarea')

      if (textarea) {
        this.cursorPos = textarea.selectionStart
      }

      this.syncMentionsWithText()

      if (
        this.mentionIndex !== -1 &&
        this.formData.note[this.mentionIndex] !== '@'
      ) {
        this.resetMention()
        return;
      }
      if (this.showMention) {
        this.filterEmployees()
      }
    },
    openMentionByButton() {
      this.isOpeningMention = true
      this.$nextTick(() => {
        const input = this.$refs.noteInput
        if (!input || !input.$el) return

        const textarea = input.$el.querySelector('textarea')
        if (!textarea) return

        textarea.focus()

        this.cursorPos = textarea.selectionStart
        this.mentionIndex = this.cursorPos

        this.formData.note =
          this.formData.note.slice(0, this.cursorPos) +
          '@' +
          this.formData.note.slice(this.cursorPos)

        this.cursorPos += 1

        this.$nextTick(() => {
          textarea.setSelectionRange(this.cursorPos, this.cursorPos)
          this.openMention(textarea)
          this.isOpeningMention = false
        })
      })
    },
    openMention(textarea) {
      this.showMention = true

      this.filterEmployees()
      if (textarea) {
        this.calculateDropdownPosition(textarea)
      }
    },
    selectMention(emp) {
      const nameText = `@${emp.username}`

      const before = this.formData.note.slice(0, this.mentionIndex)
      const after = this.formData.note.slice(this.cursorPos)

      this.formData.note = before + nameText + ' ' + after

      this.mentions.push({
        id: emp.id,
        name: emp.username,
        start: this.mentionIndex,
        length: nameText.length
      })

      this.resetMention()
    },
    resetMention() {
      this.showMention = false
      this.mentionIndex = -1
      // this.filteredEmployees = []
    },
    calculateDropdownPosition(textarea) {
      if (!textarea) return

      const wrapper = textarea.closest('.input-wrapper')
      if (!wrapper) return

      const textareaRect = textarea.getBoundingClientRect()
      const wrapperRect = wrapper.getBoundingClientRect()

      const lineHeight = 22

      const caretPos = textarea.selectionStart

      const textBeforeCursor = textarea.value.slice(0, caretPos)
    
      const lines = textBeforeCursor.replace(/\r\n/g, '\n').split('\n')
      const currentLine = lines.length - 1

      // 🔥 TÍNH TƯƠNG ĐỐI WRAPPER
      this.dropdownTop =
        textareaRect.top -
        wrapperRect.top +
        (currentLine + 1) * lineHeight

      this.dropdownLeft =
        textareaRect.left -
        wrapperRect.left +
        12
    },
    syncMentionsWithText() {
      const text = this.formData.note

      this.mentions = this.mentions.filter(m => {
        const mentionText = `@${m.name}`
        return text.substr(m.start, mentionText.length) === mentionText
      })
    },
    getMentionQuery() {
      if (this.mentionIndex === -1) return ''
      
      return this.formData.note
        .slice(this.mentionIndex + 1, this.cursorPos)
        .trim()
    },
    filterEmployees() {
      const query = this.getMentionQuery().toLowerCase()

      this.filteredEmployees = this.app.employeeList.filter(e => {
        if (!e.active) return false

        if (!query) return true

        return e.username.toLowerCase().includes(query)
      })
    },
    handleClickOutsideMention(e) {
      if (!this.showMention) return

      const dropdown = this.$refs.mentionDropdown
      const textarea =
        this.$refs.noteInput?.$el?.querySelector('textarea')

      if (!dropdown || !textarea) return

      // Click trong dropdown hoặc textarea → bỏ qua
      if (
        dropdown.contains(e.target) ||
        textarea.contains(e.target)
      ) {
        return
      }

      // Click ra ngoài
      this.resetMention()
    },
    removeFile(file) {
      const index = this.files.indexOf(file);
      if (index !== -1) {
        this.files.splice(index, 1);
      }
    },
    fileSelected(e) {
      if (!e.target.files || e.target.files.length === 0) {
        console.warn("Không có file nào được chọn.");
        return;
      }
      const MAX_SIZE = 200 * 1024 * 1024; // 200MB cho mỗi file và cho tổng file
      const selectedFiles = Array.from(e.target.files);

      const validFiles = [];
      let totalSize = 0;
      selectedFiles.forEach((file) => {
        if (file.size > MAX_SIZE) {
          this.alert("error", `Tệp ${file.name} vượt quá 200MB. Không thể tải lên`);
          return;
        }
        if (totalSize + file.size > MAX_SIZE) {
          this.alert(
            "error",
            `Tổng dung lượng tệp vượt quá 200MB. Không thể thêm ${file.name}`
          );
          return;
        }
        validFiles.push(file);
        totalSize += file.size;
      });

      this.files = validFiles;
      this.$refs.files.value = "";
    },
    async getEmployee() {
      const res = await HTTP.get("/api/employee/get-all");
      this.employeeOptions = res.data;
    },
    resetFormData() {
      const now = new Date();
      const tenMinutesLater = new Date(now.getTime() + 10 * 60 * 1000);

      this.formData = {
        title: "",
        createTime: now,
        startTime: now,
        endTime: tenMinutesLater,
        note: "",
        time: "",
        selectedEmployee: [],
        notification: false,
        fileIds: "",
        processId: "",
        workflowId: "",
      };
      this.files = [];
    },
    close() {
      this.resetFormData();
      this.$emit("close-dialog");
    },
    async createHistory() {
      if (this.formData.note.trim().length == 0) return;
      const hostContactId = this.selectedContact ? this.selectedContact.id : (this.contactIds && this.contactIds[0]);
      if (hostContactId) {
        await this.uploadFiles(hostContactId);
      }

      const employeeIds = this.employeeOptions
        .filter((user) => this.formData.selectedEmployee.includes(user.username))
        .map((user) => user.id);

      const buildPayload = (contactId, workflowId) => ({
        endTime: new Date(this.formData.endTime).getTime(),
        note: this.formData.note,
        employeeIds: employeeIds,
        contactId: contactId,
        type: "create",
        fileIds: this.formData.fileIds,
        processId: this.processId,
        workflowId: workflowId,
        mention: JSON.stringify(this.mentions),
      });

      try {
        if (Array.isArray(this.contactIds) && this.contactIds.length > 0) {
          const results = await Promise.all(
            this.contactIds.map((id) =>
              HTTP.post("/api/activity/create", buildPayload(id, this.workflowIdOverride))
            )
          );
          const allOk = results.every((r) => r && r.status === "success");
          if (allOk) {
            this.$message.success("Thêm ghi chú thành công!");
            this.resetFormData();
            this.$emit("created");
            this.$emit("update");
          } else {
            this.$message.error("Một số ghi chú không tạo được. Vui lòng thử lại.");
          }
        } else {
          const data = buildPayload(
            this.selectedContact.id,
            this.workflowIdOverride
              ?? this.selectedContact.processAndWorkflow.find(
                (f) => f.processId === this.processId
              )?.workflowId
          );
          const response = await HTTP.post("/api/activity/create", data);
          if (response.status === "success") {
            this.$message.success("Thêm ghi chú thành công!");
            this.resetFormData();
            this.$emit("created");
            this.$emit("update");
          }
        }
      } catch (error) {
        console.error("Lỗi khi tạo ghi chú:", error);
      }
    },
    async uploadFiles(contactId) {
      const uploadUrl = this.getUploadUrl(contactId);

      for (const file of this.files) {
        const formData = new FormData();
        formData.append("file", file);
        try {
          const res = await HTTP.post(uploadUrl, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (res.status === "success") {
            const newFileIds = res.data;

            if (this.formData.fileIds) {
              this.formData.fileIds += "," + newFileIds.join(",");
            } else {
              this.formData.fileIds = newFileIds.join(",");
            }
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          this.alert("error", "Tải lên thất bại");
        }
      }
    },
    getUploadUrl(contactId) {
      let HOST = "https://contact.salework.net";
      // let HOST = "http://localhost:9090";
      // if (Config.DEV) {
      //   HOST = "http://localhost:9090";
      // } else {
      //   HOST = "https://zalo.salework.net";
      // }
      return HOST + "/api/contact-file/upload?contactId=" + contactId;
    },
    updatePickerOptions() {
      this.startTimeOptions = this.getStartTimePickerOptions();
      this.endTimeOptions = this.getEndTimePickerOptions();
    },
    updateEndTimeOptions() {
      this.endTimeOptions = this.getEndTimePickerOptions();
    },
    getStartTimePickerOptions() {
      const now = new Date();
      const createTime = new Date(this.formData.createTime);

      if (createTime.toDateString() === now.toDateString()) {
        return {
          selectableRange: `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()} - 23:59:59`,
        };
      }
      return {
        selectableRange: "00:00:00 - 23:59:59",
      };
    },
    getEndTimePickerOptions() {
      if (!this.formData.startTime) return { selectableRange: "00:00:00 - 23:59:59" };
      const startTime = new Date(this.formData.startTime);
      return {
        selectableRange: `${startTime.getHours()}:${startTime.getMinutes()}:${startTime.getSeconds()} - 23:59:59`,
      };
    },
  },
  watch: {
    // "formData.startTime"() {
    //   this.updateEndTimeOptions();
    // },
  },
  created() {
    this.getEmployee();
    this.filteredEmployees = this.app.employeeList.filter(em => em.active);
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutsideMention)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleClickOutsideMention)
  },
};
</script>

<style scoped>
.el-input--small >>> .el-input__inner {
  padding-right: 0px !important;
}

.el-select >>> .el-tag.el-tag--info {
  max-width: 110px !important;
}

.upload >>> .el-upload {
  width: 100%;
  overflow: hidden;
}

.upload >>> .el-upload-dragger {
  height: 100%;
  width: 100%;
  border: 1px #ffffff solid;
  overflow: hidden;
}

.upload >>> .el-upload-dragger {
  height: 100%;
  width: 100%;
  border: 1px #ffffff solid;
}

.upload.no-click >>> .el-upload {
  cursor: no-drop !important;
}

.upload-input >>> input {
  cursor: pointer;
  border-radius: 4px 0px 0px 4px;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 40px);
}
.input-wrapper {
  position: relative;
  width: 100%;
}

.char-counter {
  font-size: 12px;
  color: gray;
  pointer-events: none;
}
.mention-wrapper {
  position: relative;
}

.mention-dropdown {
  position: absolute;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  min-width: 200px;
  max-height: 220px;
  overflow-y: auto;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
}

.mention-item {
  padding: 8px 12px;
  cursor: pointer;
}

.mention-item:hover {
  background: #f2f4f7;
}
</style>
